// extracted by mini-css-extract-plugin
module.exports = {"nft-page-container":"Nft_nft-page-container__2JjAv","recent-sales-sidebar-container":"Nft_recent-sales-sidebar-container__2DwQr"};